import { render, staticRenderFns } from "./SpaceSettingsNav.vue?vue&type=template&id=3576835b&"
import script from "./SpaceSettingsNav.vue?vue&type=script&lang=js&"
export * from "./SpaceSettingsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports